<div *ngIf="message" class="media" [ngClass]="{ 'fw-bold': message.isChannelUnread }">
  <div class="d-flex" [routerLink]="message.channelLink">
    <app-small-profile-image
      [profileImage]="message.messageAuthor.userImage"
      [accountStatus]="message.messageAuthor.userStatus"
      [dataTestId]="'user-image'"
      [width]="32"
      [height]="32"
      [class]="'rounded-circle'"
      [fontSize]="'0.3rem'"
    ></app-small-profile-image>
    <div role="button" [routerLink]="message.channelLink" class="media-body align-self-center ms-2">
      <div class="text-holder">
        <div class="text-truncate" title="{{ message.channelFriendlyName }}">
          <a data-test-id="channel-name" class="channel-name">{{ message.channelFriendlyName }}</a>
        </div>
        <div
          class="text-truncate"
          *ngIf="message.messageAuthor && message.isGroupMessage"
          title="{{ message.messageAuthor.userName }}"
        >
          {{ message.messageAuthor.userName }}
        </div>
      </div>
    </div>
  </div>

  <div role="button" [routerLink]="message.channelLink">
    <ng-container>
      <div
        data-test-id="message-body"
        class="text-truncate"
        title="{{ message.messageBody }}"
        [innerHTML]="message.messageBody"
      ></div>
    </ng-container>
  </div>
  <div
    role="button"
    [routerLink]="message.channelLink"
    data-test-id="message-date"
    class="text-truncate small fw-normal"
    title="{{ message.dateCreated | date: DATE_TIME_FORMAT_SHORT }}"
  >
    {{ message.dateCreated | date: DATE_TIME_FORMAT_SHORT }}
  </div>
</div>
